(function () {
  function adaptTitleSize() {
    var titleBlock = document.querySelector('product-title .text-block');
    if (!titleBlock) return;

    var len = titleBlock.textContent.trim().length;

    var size;
    if (len > 70) {
      size = 'clamp(15px, 1.6vw, 19px)';
    } else if (len > 55) {
      size = 'clamp(17px, 1.9vw, 22px)';
    } else if (len > 40) {
      size = 'clamp(19px, 2.2vw, 26px)';
    } else {
      return;
    }

    titleBlock.style.setProperty('--font-size', size);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adaptTitleSize);
  } else {
    adaptTitleSize();
  }
})();
